import React from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import RV from "simple-react-validator";
import InputMask from 'react-input-mask';
import * as CONFIG from "./_config";
import ls from "local-storage";
import { Helmet } from "react-helmet";
const baseURL = 'https://api.thehiringengine.com/api/customer/hays_market_berthoud/jobs';




toast.configure();
const axios = require("axios");
class Employment_HaysMarket extends React.Component {
	constructor(props) {
		super(props);
		this.validator = new RV();

		this.validator.visibleFields = [];
		this.state = {
			date: new Date(),
			formControls: {}
		};
		this.myRef = React.createRef();

	}


	onChange = date => this.setState({ date })

	componentDidUpdate(prevProps, prevState) {



	}

	componentDidMount() {

		let config = {
			method: "get",
			url: baseURL,

		};
	 
		axios(config)
			.then((response) => {
			 	this.setState({ jobs: response.data })
			})
			.catch(function (error) {
				console.log(error);
			});

		ls.set('redirectTo', window.location.href);
	}

	 
	asyncScriptOnLoad = () => {
		// this.setState({ callback: "called!" });
		// console.log("scriptLoad - reCaptcha Ref-", this._reCaptchaRef);
	};



	Employment = async (e) => {

		e.preventDefault();
		const datails = this.state.formControls;
		var body = '<table  border="0px" style="border-collapse: collapse;width: 100%; text-align:left;border:1px #537926 solid;" cellpadding="3" cellspacing="0"> &&& </table>';
		// var body = '<table style="border-collapse: collapse;width: 100%; text-align:left"> &&& </table>';
		var tr = '';

		if (!this.validator.allValid()) {
			this.validator.showMessages();

			// console.log('this.validator',this.validator);
			this.forceUpdate();
			return false;
		}




	}

	render() {
		const ColoredLine = ({ marginTop }) => (
			<hr
				style={{
					color: "black",
					marginTop: marginTop,
					borderTop: "1px dashed",

				}}
			/>
		);
		return (
			<div>
				<div className="main-container default-page pt-5 mt-5">

					{CONFIG.DATA.THEME === 2 ?
						<section id="apus-breadscrumb" className="breadcrumb-page apus-breadscrumb" style={{ backgroundColor: '#f3ffd9' }}>
							<div className="container">
								<div className="wrapper-breads">
									<div className="wrapper-breads-inner">
										<div className="breadscrumb-inner">
											<h2 className="bread-title">Employment</h2>
											<ol className="breadcrumb ml-5">
												<li><a href="/">Home</a></li>
												<li><a href="/employment">Employment</a></li>
											</ol>
										</div>
									</div>
								</div>
							</div>
						</section>
						:
						<div className="title-breadcrumb">
							<div className="container">
								<header className="entry-header">
									<h1 className="entry-title">Employment</h1>
								</header>
								<div className="breadcrumbs">
									<Link to="/">Home</Link>
									<span className="separator">/</span>
									<span> Employment</span>
								</div>
							</div>
						</div>
					}
					<div className="clearfix"></div>
					<div className="container">
						<div className="row">
							<div className="col-xs-12 ">
								<div className="page-content default-page">
									<article
										style={{ textAlign: "left" }}
										id="post-8359"
										className="pt-5 post-8359 page type-page status-publish hentry"
									>
										<div className="entry-content">
											<div className="vc_row wpb_row vc_row-fluid">
												<div className="row-container">
													<div className="wpb_column vc_column_container vc_col-sm-12">
														<div className="vc_column-inner">
															<div className="wpb_wrapper">
																{CONFIG.DATA.BACKEND_HOST == "dicksfreshmarket" ?
																	<div className="wpb_text_column wpb_content_element ">
																		<div className="wpb_wrapper">
																			<p>At Dick’s Fresh Market we are always seeking Clean, Neat, Fresh & Friendly talent to grow with our expanding company.</p>
																			<p>Our store locations in Osceola, Amery, River Falls, Menomonie, and Wabasha offer both part-time and full-time opportunities that support flexible scheduling.</p>
																			<p>Our full-time team member benefits include health, dental, life and HSA insurance benefits with paid training and paid time off available. </p>
																			<br />
																			<p>Apply online for an essential and stable career opportunity with one of our amazing teams today!</p>
																		</div>
																	</div>
																	: ""}
																<div className="wpb_text_column wpb_content_element ">
																	<div className="wpb_wrapper">
																		<p>WE ARE A COMPLETE DRUG FREE WORKPLACE</p>
																		<div>
																			<ol>
																				<li>
																					We consider applicants for all
																					positions without regard to race,
																					color, religion, sex, national origin,
																					age, marital or military status, the
																					presence of a non-job-related medical
																					condition or disability, or any other
																					legally protected status. We comply
																					with all applicable laws governing
																					employment practices, and we do not
																					discriminate on the basis of any
																					unlawful criteria.
																				</li>
																				<li>
																					This application will be considered
																					current for only 30 days from the date
																					of completion.
																				</li>
																				<li>
																					All questions must be answered for the
																					application to be considered. If not
																					applicable, please indicate with N/A.
																				</li>
																			</ol>
																		</div>
																	</div>

																</div>


																<table id="team-engine-jobs-table" className="stripe dataTable no-footer" role="grid">
																	<thead>
																		<tr role="row">
																			<th className="sorting_asc" tabIndex="0" aria-controls="team-engine-jobs-table"
																				rowSpan="1" colSpan="1" aria-sort="ascending" aria-label="Job Title: activate to sort column descending"
																				style={{
																					width: '640.819px'

																				}}>Job Title</th>
																			<th className="sorting" tabIndex="0" aria-controls="team-engine-jobs-table" rowSpan="1" colSpan="1" aria-label="Location: activate to sort column ascending" style={{ width: '426.181px' }}>Location</th></tr>
																	</thead>

																	<tbody>
																		{this.state.jobs ?

																			this.state.jobs.map((ele) => {
																				return (
																					<tr role="row" className="odd">
																						<td className="sorting_1">
																							<a href={`https://apply.teamengine.io/apply/${ele.job_hash}?utm_source=careers_page`} target="_blank">{ele.title}</a></td>
																						<td>{ele.city}</td></tr>
																				)
																			})

																			: ''}

																	</tbody></table>



																<Helmet>
																	<script type="text/javascript" src="https://embed.teamengine.io/v0.1/bundle.js"></script>
																</Helmet>
																<div id="team-engine-careers-widget" data-orgKey="hays_market"></div>







															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</article>
									<div id="comments" className="comments-area"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default Employment_HaysMarket;
